{
  "(optional)": "(opcjonalne)",
  "(required)": "(wymagane)"
}
